import React, { useState, useEffect } from 'react';
import moment from "moment";
import { FuncionarioDados, ContrachequeEntidade } from '../../../entidades';
import { Alert, Box, Col, Row } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';

import { Lista } from '../Lista';

interface IProps {
  especie: ContrachequeEntidade
}

export const Especie: React.FC<IProps> = ({
  especie
}) => {
  const [AlertText, setAlertText] = useState<string>("");
  const [Especie, setEspecie] = useState<ContrachequeEntidade>();

  useEffect(() => {
    (async () => {
      try {
        setEspecie(especie);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  return (
    <Row>
      <Col>
        <Box title={especie.Especie.DS_PLANO}>

          <div className={"mb-4"}>
            <b>ESPÉCIE:</b> {especie.Especie.DS_ESPECIE}<br />
            {/* <b>PROCESSO:</b> {especie.Especie.NUM_PROCESSO}/{especie.Especie.ANO_PROCESSO} */}
          </div>

          <br />

          <Lista lista={especie.Lista} CdPlano={especie.Especie.CD_PLANO} />

        </Box>
      </Col>
    </Row>
  );
}